import React from 'react';
import { InfoIcon } from '../../icons/info-icon';
import { disclaimerStyle } from '../../styles';
import { COOKIE_CMS_SERVICE_DISCLAIMER, SERVICE_DISCLAIMER_MESSAGE } from '../../components/constants';
import { getCookie } from '../../utils';

export const ServiceFeeDisclaimer = () => {
    const serviceDisclaimer = getCookie(COOKIE_CMS_SERVICE_DISCLAIMER);
    return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', margin: '24px 24px 0px 24px' }}>
            <div>
                <InfoIcon />
            </div>
            <p style={disclaimerStyle}>{serviceDisclaimer || SERVICE_DISCLAIMER_MESSAGE}</p>
        </div>
    );
};
